'use client';

import { useAtom } from 'jotai';
import { Loader2 } from 'lucide-react';

import { navigationLoadingAtom } from '@/components/app/atoms';

export function NavigationLoadingIndicator() {
    const [isNavigationLoading] = useAtom(navigationLoadingAtom);

    return (
        <div
            className={`content-loading-indicator ${
                isNavigationLoading ? 'active' : ''
            }`}
        >
            <div className="flex items-center space-x-2 bg-background/80 backdrop-blur-sm border rounded-md px-2 py-1 shadow-sm">
                <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
                <span className="text-xs text-muted-foreground">Loading</span>
            </div>
        </div>
    );
}
